import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10 text-white md:mt-14">
      <h1 className="text-3xl md:text-4xl font-bold mb-6 text-lime-400">
        Privacy Policy – iqcage.com
      </h1>

      <p className="mb-4">
        At <strong>iqcage.com</strong>, your privacy is extremely important to
        us. This policy outlines what personal data we collect, how we use it,
        and how we keep it safe.
      </p>

      <h2 className="text-2xl font-semibold text-lime-300 mt-6 mb-2">
        1. Information We Collect
      </h2>
      <ul className="list-disc list-inside mb-4 space-y-1">
        <li>Email address and username upon registration</li>
        <li>Gameplay activity and betting history</li>
        <li>Deposit and withdrawal transaction details</li>
        <li>Device, IP address, and browser type for security</li>
      </ul>

      <h2 className="text-2xl font-semibold text-lime-300 mt-6 mb-2">
        2. How We Use Your Data
      </h2>
      <p className="mb-4">
        We use your information to:
        <ul className="list-disc list-inside ml-4 mt-1">
          <li>Operate games and manage accounts</li>
          <li>Detect fraud, bots, or abuse</li>
          <li>Improve platform performance and features</li>
          <li>Send important updates (we never spam)</li>
        </ul>
      </p>

      <h2 className="text-2xl font-semibold text-lime-300 mt-6 mb-2">
        3. Cookies & Analytics
      </h2>
      <p className="mb-4">
        We use cookies to improve your experience and understand user behavior
        using analytics tools. You can disable cookies in your browser settings
        if you prefer.
      </p>

      <h2 className="text-2xl font-semibold text-lime-300 mt-6 mb-2">
        4. Data Sharing
      </h2>
      <p className="mb-4">
        We never sell or rent your personal data. We may share information only
        with trusted third-party services (e.g., Firebase, payment gateways)
        required to operate iqcage.com.
      </p>

      <h2 className="text-2xl font-semibold text-lime-300 mt-6 mb-2">
        5. Your Rights
      </h2>
      <ul className="list-disc list-inside mb-4 space-y-1">
        <li>You can request access to your personal data.</li>
        <li>You may request data deletion at any time.</li>
        <li>You can opt out of non-essential emails.</li>
      </ul>

      <h2 className="text-2xl font-semibold text-lime-300 mt-6 mb-2">
        6. Data Security
      </h2>
      <p className="mb-4">
        We use strong encryption, secure authentication, and industry-standard
        security practices to protect your data.
      </p>

      <h2 className="text-2xl font-semibold text-lime-300 mt-6 mb-2">
        7. Changes to This Policy
      </h2>
      <p className="mb-4">
        We may update this privacy policy from time to time. The latest version
        will always be available at iqcage.com/privacy.
      </p>

      <p className="mt-8 italic text-sm text-slate-400">
        Last updated:{" "}
        {new Date().toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })}
      </p>
    </div>
  );
}
